import type { EditorThemeClasses } from 'lexical'

export const LexicalEditorTheme: EditorThemeClasses = {
  block: 'LexicalEditorTheme__block',
  blockCursor: 'LexicalEditorTheme__blockCursor',
  characterLimit: 'LexicalEditorTheme__characterLimit',
  code: 'LexicalEditorTheme__code',
  inlineBlock: 'LexicalEditorTheme__inlineBlock',

  heading: {
    h1: 'LexicalEditorTheme__h1',
    h2: 'LexicalEditorTheme__h2',
    h3: 'LexicalEditorTheme__h3',
    h4: 'LexicalEditorTheme__h4',
    h5: 'LexicalEditorTheme__h5',
    h6: 'LexicalEditorTheme__h6',
  },
  hr: 'LexicalEditorTheme__hr',
  hrSelected: 'LexicalEditorTheme__hrSelected',
  indent: 'LexicalEditorTheme__indent',
  link: 'LexicalEditorTheme__link',
  list: {
    checklist: 'LexicalEditorTheme__checklist',
    listitem: 'LexicalEditorTheme__listItem',
    listitemChecked: 'LexicalEditorTheme__listItemChecked',
    listitemUnchecked: 'LexicalEditorTheme__listItemUnchecked',
    nested: {
      listitem: 'LexicalEditorTheme__nestedListItem',
    },
    olDepth: [
      'LexicalEditorTheme__ol1',
      'LexicalEditorTheme__ol2',
      'LexicalEditorTheme__ol3',
      'LexicalEditorTheme__ol4',
      'LexicalEditorTheme__ol5',
    ],
    ul: 'LexicalEditorTheme__ul',
  },
  ltr: 'LexicalEditorTheme__ltr',
  mark: 'LexicalEditorTheme__mark',
  markOverlap: 'LexicalEditorTheme__markOverlap',
  paragraph: 'LexicalEditorTheme__paragraph',
  placeholder: 'LexicalEditorTheme__placeholder',
  quote: 'LexicalEditorTheme__quote',
  relationship: 'LexicalEditorTheme__relationship',
  rtl: 'LexicalEditorTheme__rtl',
  tab: 'LexicalEditorTheme__tabNode',
  table: 'LexicalEditorTheme__table',
  tableAddColumns: 'LexicalEditorTheme__tableAddColumns',
  tableAddRows: 'LexicalEditorTheme__tableAddRows',
  tableAlignment: {
    center: 'LexicalEditorTheme__tableAlignmentCenter',
    right: 'LexicalEditorTheme__tableAlignmentRight',
  },
  tableCell: 'LexicalEditorTheme__tableCell',
  tableCellActionButton: 'LexicalEditorTheme__tableCellActionButton',
  tableCellActionButtonContainer: 'LexicalEditorTheme__tableCellActionButtonContainer',
  tableCellHeader: 'LexicalEditorTheme__tableCellHeader',
  tableCellResizer: 'LexicalEditorTheme__tableCellResizer',
  tableCellSelected: 'LexicalEditorTheme__tableCellSelected',
  tableFrozenColumn: 'LexicalEditorTheme__tableFrozenColumn',
  tableRowStriping: 'LexicalEditorTheme__tableRowStriping',
  tableScrollableWrapper: 'LexicalEditorTheme__tableScrollableWrapper',
  tableSelected: 'LexicalEditorTheme__tableSelected',
  tableSelection: 'LexicalEditorTheme__tableSelection',
  text: {
    bold: 'LexicalEditorTheme__textBold',
    code: 'LexicalEditorTheme__textCode',
    italic: 'LexicalEditorTheme__textItalic',
    strikethrough: 'LexicalEditorTheme__textStrikethrough',
    subscript: 'LexicalEditorTheme__textSubscript',
    superscript: 'LexicalEditorTheme__textSuperscript',
    underline: 'LexicalEditorTheme__textUnderline',
    underlineStrikethrough: 'LexicalEditorTheme__textUnderlineStrikethrough',
  },
  upload: 'LexicalEditorTheme__upload',
}
